import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Preloader from "../../../components/UI/Preloader/Preloader";
import useMakeRequest from "../../../hooks/useMakeRequest";
import LicenseProductsList from "../LicenseProductsList/LicenseProductsList";
import "./LicenseSlider.sass";

function LicenseSlider() {
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const setSlider1 = {
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  useEffect(() => {
    setParams({
      c: "accountStore",
      a: "userLicenses2",
    });
  }, []);

  if (hasError && error !== "") {
    throw new Error(error);
  }

  return (
    <div className="SliderWrapper">
      {isLoading && <Preloader className="preloaderWrapper" />}

      {result && result.length > 0 ? (
        <>
          {/* list of software providers */}
          <Slider
            asNavFor={nav1}
            ref={(slider2) => setNav2(slider2)}
            slidesToShow={6}
            swipeToSlide
            focusOnSelect
            className="Slider"
            infinite={!(result.length <= 6)}
            {...setSlider1}
            arrow="true"
          >
            {result.map((provider, i) => {
              return (
                <div className="Slides" key={i}>
                  <img src={provider.product_img} alt="" />
                </div>
              );
            })}
          </Slider>
          {/* list of products and licenses of the active provider */}
          <Slider
            slidesToShow={1}
            asNavFor={nav2}
            ref={(slider1) => setNav1(slider1)}
            className="SliderLic"
            arrow="false"
            fade
          >
            {result.map((provider, index) => (
              <LicenseProductsList key={index} provider={provider} />
            ))}
          </Slider>
        </>
      ) : (
        <div className="SliderError">You have no licenses yet</div>
      )}
    </div>
  );
}

export default LicenseSlider;
